import { PROGRESS_START } from '../../mutation-types';
import ewalletApi from '../../../api/ewallet';

const defaultState = () => ({
    ewalletHistoryPagination: {},
    ewalletHistoryResults: [],
    ewalletBalance: ''
});

const state = defaultState();

const mutations = {
    listBalance(state, data) {
        state.ewalletBalance = parseInt(data.balance);
    },
    listHistory(state, data) {
        state.ewalletHistoryPagination = data.pagination
        state.ewalletHistoryResults = data.data
    },
};

const actions = {
    getBalance({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        ewalletApi.getBalanceEwallet().then(({ data: { data } }) => {
            commit('listBalance', data);
        })
    },
    getHistory({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        ewalletApi.getHistoryEwallet({ limit: value.limit, page: value.page }).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listHistory', { data: 'error', pagination: data.pagination });
            } else {
                commit('listHistory', { data: data.results, pagination: data.pagination });
            }
        })
    },
    filter({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        ewalletApi.getHistoryEwallet({ 'filter[0][value]': value.value, 'filter[0][comparison]': value.comparison, 'filter[0][type]': value.type, 'filter[0][field]': value.field, limit: value.limit, page: value.page }).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listHistory', { data: 'error', pagination: data.pagination });
            } else {
                commit('listHistory', { data: data.results, pagination: data.pagination });
            }
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}